import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';


import { GadgetsApi } from 'src/app/ajs-upgraded-providers';

@Component({
    selector: 'widget-settings',
    templateUrl: './widget-settings.component.html',
    styleUrls: ['./widget-settings.component.scss'],
    standalone: false
})
export class WidgetSettingsComponent implements OnInit {
  widgetUrl;
  additionalParams;
  loading;

  widget: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<WidgetSettingsComponent>,
    private sanitizer: DomSanitizer,
    private changeDetectorRef: ChangeDetectorRef,
    private gadgetsApi: GadgetsApi) {
      this.widget = this.data.widget;
  }

  ngOnInit() {
    this.loading = true;

    setTimeout(this._stopLoader.bind(this), 3000);

    this.widgetUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.widget.url);
    this.additionalParams = this.widget.additionalParams;

    this._registerRpc();

    this.changeDetectorRef.detectChanges();
  }

  _registerRpc() {
    if (this.gadgetsApi) {
      setTimeout(() => {
        this.gadgetsApi.rpc.register('rscmd_saveSettings',
          this._saveSettings.bind(this));
        this.gadgetsApi.rpc.register('rscmd_closeSettings',
          this._closeSettings.bind(this));
        this.gadgetsApi.rpc.register('rscmd_getAdditionalParams',
          this._getAdditionalParams.bind(this));

        this.gadgetsApi.rpc.setupReceiver('widget-modal-frame');
      });
    }
  }

  _stopLoader() {
    this.loading = false;
  }

  _getAdditionalParams() {
    this._stopLoader();

    return this.additionalParams;
  }

  _saveSettings(data) {
    this.dialogRef.close(data);
  }

  _closeSettings() {
    this.dialogRef.close();
  }

}
